import { Button, ButtonProps } from 'antd';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { Export } from 'icons';

import styles from './ExportButton.module.scss';

export const ExportButton = ({ className, ...props }: ButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button {...props} className={classNames(styles.exportButton, className)} icon={<Export />}>
      <span>{t('exportRequests')}</span>
    </Button>
  );
};
